<template>
  <section class="">
    <div class="message-header">
      <div>Welcome {{contact.firstName}}</div>
      <button class="delete" aria-label="delete" @click="cancel"></button>
    </div>
    <div class="message-body">
      <table class="mb-5">
        <tbody>
            <tr v-if="contact.email">
                <th class="pr-5">Email:</th>
                <td>{{contact.email}}</td>
            </tr>
            <tr v-if="contact.mobile">
                <th class="pr-5">Mobile:</th>
                <td>{{contact.mobile}}</td>
            </tr>
            <tr v-if="contact.contactType">
                <th class="pr-5">Role:</th>
                <td class="pr-5">{{contact.contactType.name}}</td>
            </tr>
            <tr v-if="contact.companyName">
                <th class="pr-5">Company:</th>
                <td>{{contact.companyName}}</td>
            </tr>
            <tr v-if="contact.host">
                <th class="pr-5">Visiting:</th>
                <td>{{contact.host.firstName}} {{contact.host.lastName}}</td>
            </tr>
        </tbody>
      </table>
      <button @click.prevent="confirm" class="button is-success">Yes - Those details are correct</button>
      <button @click.prevent="change" class="button is-success is-outlined ml-2">I need to change something</button>
    </div>
  </section>
</template>

<script>
export default {
  props: ['props'],
  data() {
    return {
      contact: this.props.contact
    }
  },
  methods: {
    confirm() {
      this.contact.name =  [this.contact.firstName,this.contact.lastName].join(' ');
      this.$emit('confirm', this.contact)
      this.$emit('close');
    },
    change() {
      this.contact.name =  [this.contact.firstName,this.contact.lastName].join(' ');
      this.$emit('change', this.contact)
      this.$emit('close');
    },
    cancel () {
      this.$emit('cancel')
      this.$emit('close');
    }
  },
  mounted () {
    if (this.$listeners.render) this.$listeners.render(this)
  }
};
</script>
